export function AutoUnsubscribe(blackList = []) {
    return function (constructor) {
        const original = constructor.prototype.ngOnDestroy || function () {};

        constructor.prototype.ngOnDestroy = function () {
            for (const prop of Object.keys(this)) {
                const property = this[prop];
                if (!blackList.includes(prop)) {
                    // Verificar si la propiedad tiene el método `unsubscribe`
                    if (property && typeof property.unsubscribe === 'function') {
                        try {
                            property.unsubscribe();
                        } catch (err) {
                            console.warn(`Error al intentar desuscribirse de ${prop}:`, err);
                        }
                    }
                }
            }
            original.apply(this, arguments);
        };
    };
}
